export default __webpack_public_path__ + "static/media/1746.634bfda5.png";